import { render, staticRenderFns } from "./saved-messages-modal.vue?vue&type=template&id=02233442"
import script from "./saved-messages-modal.vue?vue&type=script&lang=js"
export * from "./saved-messages-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports